import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getUsers, addUser, updateUser, deleteUser } from "../services/UserServices";
import useAuthStore from "../store/useAuthStore";
import { useNavigate } from "react-router-dom";

const Users = () => {
  const token = useAuthStore((state) => state.token);
  const [userList, setUserList] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [addingUser, setAddingUser] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", role: "", pin: "" });
  const navigate = useNavigate();

  const getUsersList = async () => {
    try {
      const res = await getUsers();
      setUserList(res?.data?.data || []);
    } catch (error) {
      toast.error("Failed to fetch users");
    }
  };

  // useEffect(() => {
  //   getUsersList();
  // }, []);
  useEffect(() => {
    if (!token) {
      navigate("/");
    } else {
      getUsersList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  // Handle delete
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      try {
        await deleteUser(id);
        setUserList(userList.filter((u) => u.id !== id));
        toast.success("User deleted successfully");
      } catch {
        toast.error("Failed to delete user");
      }
    }
  };

  // Handle edit button click
  const handleEditClick = (user) => {
    setEditingUser(user.id);
    setFormData({
      name: user.name,
      email: user.email,
      role: user.role,
      pin: user.pin || "",
    });
  };

  // Save updated user
  const handleSave = async () => {
    if (!formData.name || !formData.email || !formData.role || !formData.pin) {
      toast.error("All fields are required");
      return;
    }
    try {
      await updateUser({ id: editingUser, ...formData });
      const updatedList = userList.map((u) =>
        u.id === editingUser ? { ...u, ...formData } : u
      );
      setUserList(updatedList);
      setEditingUser(null);
      toast.success("User updated successfully");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to update user");
    }
  };

  // Save new user
  const handleAddUser = async () => {
    if (!formData.name || !formData.email || !formData.role || !formData.pin) {
      toast.error("All fields are required");
      return;
    }
    try {
      await addUser(formData);
      setAddingUser(false);
      setFormData({ name: "", email: "", role: "", pin: "" });
      toast.success("User added successfully");
      getUsersList();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to add user")
    }
  };

  //   const sheetHandler = async (e) => {
  //   e.preventDefault();

  //   const res = await fetch("http://localhost:4069/api/auth/auth", {
  //     headers: {
  //       "Authorization": `Bearer ${token}`,
  //     }
  //   });

  //   const data = await res.json();

  //   // Redirect user to Google OAuth URL returned by backend
  //   window.location.href = data.url;
  // };

  // const sheetHandler = (e) => {
  //   e.preventDefault();
  //   // Redirect the browser directly to your backend route
  //   window.location.href = `http://localhost:4069/api/auth/auth?token=${token}`;
  // };

  const sheetHandler = (e) => {
    e.preventDefault();

    const createNew = window.confirm("Do you want to create a new Google Sheet?");
    let sheetName = "";

    if (createNew) {
      sheetName = window.prompt("Enter the new sheet name:");
      if (!sheetName) return alert("Sheet name is required to create a new sheet.");
    }

    const baseUrl = "https://connect.cyno.co.in/api/auth/auth";
    const queryParams = new URLSearchParams({
      token,
      createNew: createNew ? "true" : "false",
      ...(createNew && sheetName ? { sheetName } : {}),
    });

    window.location.href = `${baseUrl}?${queryParams.toString()}`;
  };


  return (
    <div className="w-full p-6">

      <h1 className="text-2xl w-8/12 mx-auto font-bold mb-6 text-center text-gray-800">
        Users
      </h1>
      <div className="w-10/12 mx-auto">
        <button
          onClick={sheetHandler}
          className="text-white text-end bg-blue-600 rounded-lg p-2 mb-2">
          Connect Sheet
        </button>
      </div>

      <div className="overflow-x-auto w-10/12 mx-auto shadow-lg rounded-2xl">
        <table className="w-full text-left border-collapse">
          <thead className="bg-gray-800 text-white">
            <tr>
              <th className="py-3 px-4">#</th>
              <th className="py-3 px-4">Name</th>
              <th className="py-3 px-4">Email</th>
              <th className="py-3 px-4">Role</th>
              <th className="py-3 px-4">Actions</th>
            </tr>
          </thead>
          <tbody>
            {userList.length > 0 ? (
              userList.map((user, index) => (
                <tr
                  key={user.id || index}
                  className={`${index % 2 === 0 ? "bg-gray-50" : "bg-white"
                    } hover:bg-gray-100 transition`}
                >
                  <td className="py-3 px-4 text-gray-600">{index + 1}</td>
                  <td className="py-3 px-4 font-medium text-gray-800">
                    {editingUser === user.id ? (
                      <input
                        type="text"
                        value={formData.name}
                        onChange={(e) =>
                          setFormData({ ...formData, name: e.target.value })
                        }
                        className="border rounded px-2 py-1 w-full"
                      />
                    ) : (
                      user.name
                    )}
                  </td>
                  <td className="py-3 px-4 text-gray-600">
                    {editingUser === user.id ? (
                      <input
                        type="email"
                        value={formData.email}
                        onChange={(e) =>
                          setFormData({ ...formData, email: e.target.value })
                        }
                        className="border rounded px-2 py-1 w-full"
                      />
                    ) : (
                      user.email
                    )}
                  </td>
                  <td>
                    {editingUser === user.id ? (
                      <select
                        value={formData.role}
                        onChange={(e) =>
                          setFormData({ ...formData, role: e.target.value })
                        }
                        className="border rounded px-2 py-1"
                      >
                        <option value="">Select Role</option>
                        <option value="admin">Admin</option>
                        <option value="sub-admin">Sub Admin</option>
                        <option value="user">User</option>
                      </select>
                    ) : (
                      <span
                        className={`inline-block px-3 py-1 text-sm rounded-full ${user.role === "admin"
                          ? "bg-blue-100 text-blue-600"
                          : "bg-green-100 text-green-600"
                          }`}
                      >
                        {user.role}
                      </span>
                    )}
                  </td>
                  <td className="py-3 px-4 flex gap-2">
                    {editingUser === user.id ? (
                      <>
                        <input
                          type="text"
                          placeholder="PIN"
                          value={formData.pin}
                          onChange={(e) =>
                            setFormData({ ...formData, pin: e.target.value })
                          }
                          className="border rounded px-2 py-1 w-20"
                        />
                        <button
                          onClick={handleSave}
                          className="px-3 py-1 bg-green-500 text-white rounded hover:bg-green-600"
                        >
                          Save
                        </button>
                        <button
                          onClick={() => setEditingUser(null)}
                          className="px-3 py-1 bg-gray-400 text-white rounded hover:bg-gray-500"
                        >
                          Cancel
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          onClick={() => handleEditClick(user)}
                          className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => handleDelete(user.id)}
                          className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600"
                        >
                          Delete
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center py-6 text-gray-500">
                  No users found
                </td>
              </tr>
            )}

            {/* Add User Row */}
            {addingUser && (
              <tr className="bg-yellow-50">
                <td className="py-3 px-4">#</td>
                <td className="py-3 px-4">
                  <input
                    type="text"
                    placeholder="Name"
                    value={formData.name}
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                    className="border rounded px-2 py-1 w-full"
                  />
                </td>
                <td className="py-3 px-4">
                  <input
                    type="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                    className="border rounded px-2 py-1 w-full"
                  />
                </td>
                <td>
                  <select
                    value={formData.role}
                    onChange={(e) =>
                      setFormData({ ...formData, role: e.target.value })
                    }
                    className="border rounded px-2 py-1"
                  >
                    <option value="">Select Role</option>
                    <option value="admin">Admin</option>
                    <option value="sub-admin">Sub Admin</option>
                    <option value="user">User</option>
                  </select>
                </td>
                <td className="py-3 px-4 flex gap-2">
                  <input
                    type="text"
                    placeholder="PIN"
                    value={formData.pin}
                    onChange={(e) =>
                      setFormData({ ...formData, pin: e.target.value })
                    }
                    className="border rounded px-2 py-1 w-20"
                  />
                  <button
                    onClick={handleAddUser}
                    className="px-3 py-1 bg-green-500 text-white rounded hover:bg-green-600"
                  >
                    Save
                  </button>
                  <button
                    onClick={() => setAddingUser(false)}
                    className="px-3 py-1 bg-gray-400 text-white rounded hover:bg-gray-500"
                  >
                    Cancel
                  </button>
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Add User Button */}
        {!addingUser && (
          <div className="text-center py-4">
            <button
              onClick={() => {
                setAddingUser(true);
                setFormData({ name: "", email: "", role: "", pin: "" });
              }}
              className="px-4 py-2 bg-indigo-500 text-white rounded-lg hover:bg-indigo-600"
            >
              + Add User
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Users;
